import React from "react";

function About() {
  return (
    <div className="container">
      <div className="py-4">
        <h1>About Page</h1>
        <p className="lead">
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Debitis
          cumque nemo exercitationem expedita aperiam, molestiae odio qui
          reprehenderit? Doloremque ut assumenda temporibus modi, alias qui
          aperiam distinctio ipsa consequatur sit!
        </p>
        <p className="lead">
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Debitis
          cumque nemo exercitationem expedita aperiam, molestiae odio qui
          reprehenderit? Doloremque ut assumenda temporibus modi, alias qui
          aperiam distinctio ipsa consequatur sit!
        </p>
        <p className="lead">
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Debitis
          cumque nemo exercitationem expedita aperiam, molestiae odio qui
          reprehenderit? Doloremque ut assumenda temporibus modi, alias qui
          aperiam distinctio ipsa consequatur sit!
        </p>
      </div>
    </div>
  );
}

export default About;
